import { axiosSmartCoolersInstance } from '@/config/apiConfig';
import {
  ISmartCooler,
  ISmartCoolerResponse,
} from '@/pages/SmartCoolers/smartCooler.interface';

export interface IFetchCoolersParams {
  page?: number;
  limit?: number;
  status?: string;
  orderBy?: string;
  order?: string;
  operatorId?: string;
}

export interface ICoolerActionPayload {
  coolerId: string;
  type: 'UPLOAD_LOGS' | 'RESTART_DEVICE';
  options: { days: number };
}

export interface ICoolerActionResponse {
  success: boolean;
  message: string;
  data?: any;
}

export const fetchCoolerList = (
  params: IFetchCoolersParams,
): Promise<{ data: ISmartCoolerResponse }> => {
  return axiosSmartCoolersInstance.get('/coolers', { params });
};

export const triggerCoolerAction = (
  payload: ICoolerActionPayload,
): Promise<{ data: ICoolerActionResponse }> => {
  return axiosSmartCoolersInstance.post(
    `/coolers/${payload.coolerId}/actions`,
    { type: payload.type, options: payload.options },
  );
};

export const fetchCoolerActionLogs = (
  coolerId: string,
  params?: Record<string, any>,
): Promise<{ data: any }> => {
  return axiosSmartCoolersInstance.get(`/coolers/${coolerId}/actions`, {
    params,
  });
};

export const fetchCoolerConnectionLogs = (
  coolerId: string,
  params?: Record<string, any>,
): Promise<{ data: any }> => {
  return axiosSmartCoolersInstance.get(`/coolers/${coolerId}/connection-logs`, {
    params,
  });
};
